import React from 'react';

import { Typography, Accordion, AccordionSummary, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LabelValueDisplay from 'components/labels/LabelValueDisplay';
import HighLabelStatus from 'components/labels/HighLabelStatus';
import HintText from 'components/labels/HintText';

// import Typography from '../Typography';

// import AppointmentsGridNew from './AppointmentsGridNew';
// import AppointmentsGrid2 from './AppointmentsGrid2';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  accordionBody: {
    margin: '15px',
  },
}));

function CustomDivider() {
  return <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />;
}

// COMPONENT
function ComponentPortfolio() {
  const { classes } = useStyles();
  return (
    <div style={{ margin: '20px' }}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography className={classes.heading}>Labels</Typography>
        </AccordionSummary>
        <div className={classes.accordionBody}>
          <div>
            <Typography>LabelValueComponent</Typography>
            <LabelValueDisplay label="My Label" value="My value" />
          </div>
          <CustomDivider />

          <div>
            <Typography>LabelStatus</Typography>
            <HighLabelStatus status="success">My label</HighLabelStatus>
          </div>
          <CustomDivider />

          <div>
            <Typography>HintText</Typography>
            <HintText>This is just a hint</HintText>
          </div>
        </div>
      </Accordion>
    </div>
  );
}

export default ComponentPortfolio;
